import request from './request'
import axios from 'axios'
import store from '@/store'
import Cookies from 'js-cookie'

// 列表信息导出(这里面有三个参数分别是查询条件，后端导出接口地址，文件名)
export const exportExcelByPost = (data, excelUrl, fileName) => {
  return request({
    method: 'post',
    url: excelUrl,
    responseType: 'blob',
    data
  }).then(function (response) {
    handleData(response, fileName)
  }).catch(function (error) {
    throw new Error(error.message)
  })
}

export const exportExcelByGet = (params, excelUrl, fileName) => {
  // 使用 axios 直接请求，以便获取响应头中的 message
  const baseURL = process.env.BASE_API
  const fullUrl = baseURL + excelUrl
  
  return axios({
    method: 'get',
    url: fullUrl,
    responseType: 'blob',
    params,
    headers: {
      'Authorization': store.getters.token ? `Bearer ${store.state.MerchantAuth.accessToken}` : ''
    }
  }).then(function (response) {
    // 检查响应类型，如果是错误响应（JSON格式的blob），需要解析错误信息
    if (response && response.data) {
      // 检查是否是错误响应（通常是 JSON 格式的 blob）
      if (response.data instanceof Blob && response.data.type === 'application/json') {
        // 读取 blob 内容并解析错误信息
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const errorData = JSON.parse(reader.result)
              let errorMessage = errorData.msg || errorData.message || '下载失败'
              
              // 如果有 failureDetails 数组，遍历并拼接所有错误信息
              if (errorData.failureDetails && Array.isArray(errorData.failureDetails) && errorData.failureDetails.length > 0) {
                const errorMessages = errorData.failureDetails.map(item => {
                  // failureDetails 可能是字符串数组，也可能是对象数组
                  if (typeof item === 'string') {
                    return item
                  } else if (item && item.errorMessage) {
                    return item.errorMessage
                  } else if (item && item.message) {
                    return item.message
                  }
                  return ''
                }).filter(msg => msg) // 过滤掉空字符串
                
                if (errorMessages.length > 0) {
                  errorMessage = errorMessages.join('，')
                }
              }
              
              // 将错误数据附加到 Error 对象上，以便调用方可以访问 failureDetails
              const errorObj = new Error(errorMessage)
              if (errorData.failureDetails) {
                errorObj.failureDetails = errorData.failureDetails
              }
              reject(errorObj)
            } catch (e) {
              reject(new Error('下载失败，无法解析错误信息'))
            }
          }
          reader.onerror = () => {
            reject(new Error('下载失败，无法读取错误信息'))
          }
          reader.readAsText(response.data)
        })
      }
      
      // 从响应头中获取 message（可能的后端返回的提示信息）
      const headers = response.headers || {}
      const message = headers['x-message'] || headers['X-Message'] || headers['message'] || headers['Message'] || null
      
      // 正常响应，处理下载
      handleData(response.data, fileName)
      
      // 返回响应信息，包括可能的 message
      return { success: true, message: message }
    } else {
      handleData(response, fileName)
      return { success: true, message: null }
    }
  }).catch(function (error) {
    // 如果错误响应是 blob 类型（JSON格式），尝试解析错误信息
    if (error.response && error.response.data instanceof Blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            let errorMessage = errorData.msg || errorData.message || error.message
            
            // 如果有 failureDetails 数组，遍历并拼接所有错误信息
            if (errorData.failureDetails && Array.isArray(errorData.failureDetails) && errorData.failureDetails.length > 0) {
              const errorMessages = errorData.failureDetails.map(item => {
                // failureDetails 可能是字符串数组，也可能是对象数组
                if (typeof item === 'string') {
                  return item
                } else if (item && item.errorMessage) {
                  return item.errorMessage
                } else if (item && item.message) {
                  return item.message
                }
                return ''
              }).filter(msg => msg) // 过滤掉空字符串
              
              if (errorMessages.length > 0) {
                errorMessage = errorMessages.join('，')
              }
            }
            
            // 将错误数据附加到 Error 对象上，以便调用方可以访问 failureDetails
            const errorObj = new Error(errorMessage)
            if (errorData.failureDetails) {
              errorObj.failureDetails = errorData.failureDetails
            }
            reject(errorObj)
          } catch (e) {
            // 如果解析失败，使用原始错误信息
            const errorMessage = error.message
            reject(new Error(errorMessage))
          }
        }
        reader.onerror = () => {
          reject(new Error(error.message))
        }
        reader.readAsText(error.response.data)
      })
    }
    // 其他类型的错误，直接抛出
    const errorMessage = error.message
    throw new Error(errorMessage)
  })
}

export function handleData (response, fileName) {
  // 如果 response 已经是 Blob，直接使用；否则创建 Blob
  let blob
  if (response instanceof Blob) {
    blob = response
  } else {
    blob = new Blob([response], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    })
  }
  // 创建下载链接
  let downloadElement = document.createElement('a')
  let href = window.URL.createObjectURL(blob)
  downloadElement.href = href
  downloadElement.download = fileName || 'download.xlsx' // 下载后文件名
  downloadElement.style.display = 'none' // 隐藏元素
  // 添加到 DOM 并触发下载
  document.body.appendChild(downloadElement)
  downloadElement.click()
  // 延迟移除，确保下载开始
  setTimeout(() => {
    document.body.removeChild(downloadElement)
    window.URL.revokeObjectURL(href) // 释放掉blob对象
  }, 100)
}



// WEBPACK FOOTER //
// ./src/api/common/exportExcel.js